import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import ProtectedRoute from '../components/ProtectedRoute';

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));
const DashboardSegment = Loadable(lazy(() => import('pages/dashboard/Segment')));

// render - Realtime
const RealtimeDefault = Loadable(lazy(() => import('pages/realtime/default')));
const RealtimeDevice = Loadable(lazy(() => import('pages/realtime/Device')));
const RealtimeJoinbox = Loadable(lazy(() => import('pages/realtime/Joinbox')));
const RealtimeAlert = Loadable(lazy(() => import('pages/realtime/Alert')));
const RealtimeLcd = Loadable(lazy(() => import('pages/realtime/Lcd')));

// render - O&M
const OnmIvCurveScan = Loadable(lazy(() => import('pages/onm/IvCurveScan')));
const OnmOutputCtrl = Loadable(lazy(() => import('pages/onm/OutputCtrl')));

// render - Report
const ReportDefault = Loadable(lazy(() => import('pages/report/default')));
const ReportMonthly = Loadable(lazy(() => import('pages/report/Monthly')));
const ReportMonthlyDetail = Loadable(lazy(() => import('pages/report/MonthlyDetail')));
const ReportWeather = Loadable(lazy(() => import('pages/report/Weather')));

const RecordInverter = Loadable(lazy(() => import('pages/record/InverterData')));
const RecordGrid = Loadable(lazy(() => import('pages/record/GridData')));
const RecordJoinbox = Loadable(lazy(() => import('pages/record/JoinboxData')));
const RecordWeahter = Loadable(lazy(() => import('pages/record/WeatherData')));
const RecordAlert = Loadable(lazy(() => import('pages/record/AlertData')));

// render control
const ControlDefault = Loadable(lazy(() => import('pages/control/default')));
const ControlHistory = Loadable(lazy(() => import('pages/control/History')));

// render OuterAdmin
// const OaPlant = Loadable(lazy(() => import('pages/outeradmin/Oa-Plant')));
// const OaPlantDetail = Loadable(lazy(() => import('pages/outeradmin/Oa-PlantDetail')));
// const OaPlantMapp = Loadable(lazy(() => import('pages/outeradmin/Oa-PlantMapp')));
// const OaAccount = Loadable(lazy(() => import('pages/outeradmin/Oa-Account')));
// const OaAccountDetail = Loadable(lazy(() => import('pages/outeradmin/Oa-AccountDetail')));
// const OaAccountMapp = Loadable(lazy(() => import('pages/outeradmin/Oa-AccountMapp')));

// render account
const PasswordChange = Loadable(lazy(() => import('pages/auth/PasswordChange')));

// redner Admin
const AdminPlant = Loadable(lazy(() => import('pages/admin/plants/PlantList')));
const AdminPlantCreate = Loadable(lazy(() => import('pages/admin/plants/PlantCreate')));
const AdminPlantMapp = Loadable(lazy(() => import('pages/admin/plants/PlantMapp')));
const AdminPlantDevices = Loadable(lazy(() => import('pages/admin/plants/PlantDevices')));
const AdminPlantWizbee = Loadable(lazy(() => import('pages/admin/plants/PlantWizbee')));

const AdminAccount = Loadable(lazy(() => import('pages/admin/users/AccountList')));
const AdminAccountCreate = Loadable(lazy(() => import('pages/admin/users/AccountCreate')));
const AdminAccountMapp = Loadable(lazy(() => import('pages/admin/users/AccountMapp')));

const AdminDeviceList = Loadable(lazy(() => import('pages/admin/devices/DeviceList')));
const AdminDeviceCreate = Loadable(lazy(() => import('pages/admin/devices/DeviceCreate')));
const AdminDeviceUnuseJb = Loadable(lazy(() => import('pages/admin/devices/UnuseJb')));

const AdminWizbeeRtu = Loadable(lazy(() => import('pages/admin/wizbee/WizbeeList')));

const AdminCircuit = Loadable(lazy(() => import('pages/admin/circuit/Circuit')));
const AdminCircuitIoPortCreate = Loadable(lazy(() => import('pages/admin/circuit/IoPortCreate')));
const AdminCircuitMbWrCreate = Loadable(lazy(() => import('pages/admin/circuit/MbWrCreate')));

const AdminSms = Loadable(lazy(() => import('pages/admin/sms/SmsList')));
const AdminSmsView = Loadable(lazy(() => import('pages/admin/sms/SmsView')));

const AdminGuarantee = Loadable(lazy(() => import('pages/admin/guarantee/Guarantee')));

// render - color
const Color = Loadable(lazy(() => import('pages/component-overview/color')));
const Typography = Loadable(lazy(() => import('pages/component-overview/typography')));
const Shadow = Loadable(lazy(() => import('pages/component-overview/shadows')));

// render - sample page
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));

// simple dev
const DevList = Loadable(lazy(() => import('pages/admin/dev/DevList')));
const DevCreate = Loadable(lazy(() => import('pages/admin/dev/DevCreate')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <ProtectedRoute>
      <DashboardLayout />
    </ProtectedRoute>
  ),
  children: [
    {
      path: '/',
      element: <Navigate to="/realtime/default" replace />
    },
    {
      path: 'password',
      element: (
        <ProtectedRoute>
          <PasswordChange />
        </ProtectedRoute>
      )
    },
    {
      path: 'dashboard',
      children: [
        {
          index: true,
          element: <Navigate to="default" replace />
        },
        {
          path: 'default',
          element: (
            <ProtectedRoute>
              <DashboardDefault />
            </ProtectedRoute>
          )
        },
        {
          path: 'segment',
          element: (
            <ProtectedRoute>
              <DashboardSegment />
            </ProtectedRoute>
          )
        }
      ]
    },
    {
      path: 'realtime',
      children: [
        {
          index: true,
          element: <Navigate to="default" replace />
        },
        {
          path: 'default',
          element: (
            <ProtectedRoute>
              <RealtimeDefault />
            </ProtectedRoute>
          )
        },
        {
          path: 'device',
          element: (
            <ProtectedRoute>
              <RealtimeDevice />
            </ProtectedRoute>
          )
        },
        {
          path: 'joinbox',
          element: (
            <ProtectedRoute>
              <RealtimeJoinbox />
            </ProtectedRoute>
          )
        },
        {
          path: 'alert',
          element: (
            <ProtectedRoute>
              <RealtimeAlert />
            </ProtectedRoute>
          )
        },
        {
          path: 'lcd/:id',
          element: (
            <ProtectedRoute>
              <RealtimeLcd />
            </ProtectedRoute>
          )
        }
      ]
    },
    {
      path: 'report',
      children: [
        {
          index: true,
          element: <Navigate to="default" replace />
        },
        {
          path: 'default',
          element: (
            <ProtectedRoute>
              <ReportDefault />
            </ProtectedRoute>
          )
        },
        {
          path: 'monthly',
          element: (
            <ProtectedRoute>
              <ReportMonthly />
            </ProtectedRoute>
          )
        },
        {
          path: 'monthlydetail',
          element: (
            <ProtectedRoute>
              <ReportMonthlyDetail />
            </ProtectedRoute>
          )
        },
        {
          path: 'weather',
          element: (
            <ProtectedRoute>
              <ReportWeather />
            </ProtectedRoute>
          )
        }
      ]
    },
    {
      path: 'record',
      children: [
        {
          index: true,
          element: <Navigate to="inverter" replace />
        },
        {
          path: 'inverter',
          element: (
            <ProtectedRoute>
              <RecordInverter />
            </ProtectedRoute>
          )
        },
        {
          path: 'grid',
          element: (
            <ProtectedRoute>
              <RecordGrid />
            </ProtectedRoute>
          )
        },
        {
          path: 'joinbox',
          element: (
            <ProtectedRoute>
              <RecordJoinbox />
            </ProtectedRoute>
          )
        },
        {
          path: 'weather',
          element: (
            <ProtectedRoute>
              <RecordWeahter />
            </ProtectedRoute>
          )
        },
        {
          path: 'alert',
          element: (
            <ProtectedRoute>
              <RecordAlert />
            </ProtectedRoute>
          )
        }
      ]
    },
    {
      path: 'control',
      children: [
        {
          index: true,
          element: <Navigate to="default" replace />
        },
        {
          path: 'default',
          element: (
            <ProtectedRoute>
              <ControlDefault />
            </ProtectedRoute>
          )
        },
        {
          path: 'history',
          element: (
            <ProtectedRoute>
              <ControlHistory />
            </ProtectedRoute>
          )
        }
      ]
    },

    {
      path: 'onm',
      children: [
        { index: true, element: <Navigate to="ivcurvescan" /> },
        {
          path: 'ivcurvescan',
          element: (
            <ProtectedRoute>
              <OnmIvCurveScan />
            </ProtectedRoute>
          )
        },
        {
          path: 'outputctrl',
          element: (
            <ProtectedRoute>
              <OnmOutputCtrl />
            </ProtectedRoute>
          )
        }
      ]
    },

    {
      path: 'admin',
      children: [
        {
          index: true,
          element: <Navigate to="plant" replace />
        },

        {
          path: 'plant',
          element: (
            <ProtectedRoute>
              <AdminPlant />
            </ProtectedRoute>
          )
        },
        {
          path: 'plant/mappuser/:id',
          element: (
            <ProtectedRoute>
              <AdminPlantMapp />
            </ProtectedRoute>
          )
        },
        {
          path: 'plant/create',
          element: (
            <ProtectedRoute>
              <AdminPlantCreate />
            </ProtectedRoute>
          )
        },
        {
          path: 'plant/devices',
          element: (
            <ProtectedRoute>
              <AdminPlantDevices />
            </ProtectedRoute>
          )
        },
        {
          path: 'plant/wizbee',
          element: (
            <ProtectedRoute>
              <AdminPlantWizbee />
            </ProtectedRoute>
          )
        },

        {
          path: 'plant/:id',
          element: (
            <ProtectedRoute>
              <AdminPlantCreate />
            </ProtectedRoute>
          )
        },
        {
          path: 'account',
          element: (
            <ProtectedRoute>
              <AdminAccount />
            </ProtectedRoute>
          )
        },
        {
          path: 'account/mappplant',
          element: (
            <ProtectedRoute>
              <AdminAccountMapp />
            </ProtectedRoute>
          )
        },
        {
          path: 'account/create',
          element: (
            <ProtectedRoute>
              <AdminAccountCreate />
            </ProtectedRoute>
          )
        },
        {
          path: 'account/:id',
          element: (
            <ProtectedRoute>
              <AdminAccountCreate />
            </ProtectedRoute>
          )
        },
        {
          path: 'device',
          element: (
            <ProtectedRoute>
              <AdminDeviceList />
            </ProtectedRoute>
          )
        },
        {
          path: 'device/create',
          element: (
            <ProtectedRoute>
              <AdminDeviceCreate />
            </ProtectedRoute>
          )
        },
        {
          path: 'device/unusejb',
          element: (
            <ProtectedRoute>
              <AdminDeviceUnuseJb />
            </ProtectedRoute>
          )
        },
        {
          path: 'device/:id',
          element: (
            <ProtectedRoute>
              <AdminDeviceCreate />
            </ProtectedRoute>
          )
        },
        {
          path: 'wizbeertu',
          element: (
            <ProtectedRoute>
              <AdminWizbeeRtu />
            </ProtectedRoute>
          )
        },

        {
          path: 'circuit/ioport/create',
          element: (
            <ProtectedRoute>
              <AdminCircuitIoPortCreate />
            </ProtectedRoute>
          )
        },
        {
          path: 'circuit/mbwr/create',
          element: (
            <ProtectedRoute>
              <AdminCircuitMbWrCreate />
            </ProtectedRoute>
          )
        },

        {
          path: 'circuit/*',
          element: (
            <ProtectedRoute>
              <AdminCircuit />
            </ProtectedRoute>
          )
        },

        {
          path: 'sms',
          element: (
            <ProtectedRoute>
              <AdminSms />
            </ProtectedRoute>
          )
        },
        {
          path: 'sms/view',
          element: (
            <ProtectedRoute>
              <AdminSmsView />
            </ProtectedRoute>
          )
        },

        {
          path: 'guarantee',
          element: (
            <ProtectedRoute>
              <AdminGuarantee />
            </ProtectedRoute>
          )
        },
        {
          path: 'dev',
          element: (
            <ProtectedRoute>
              <DevList />
            </ProtectedRoute>
          )
        },
        {
          path: 'dev/create',
          element: (
            <ProtectedRoute>
              <DevCreate />
            </ProtectedRoute>
          )
        }
      ]
    },

    {
      path: 'typography',
      element: <Typography />
    },
    {
      path: 'color',
      element: <Color />
    },
    {
      path: 'shadow',
      element: <Shadow />
    },
    {
      path: 'sample-page',
      element: <SamplePage />
    }
  ]
};

export default MainRoutes;
